import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as inviteActions from '../actions/invite-actions';

import './InviteCell.css';

class InviteCell extends Component {
  constructor(props) {
    super(props);

    this.resendInvite = this.resendInvite.bind(this);
    this.cancelInvite = this.cancelInvite.bind(this);
    this.renderActions = this.renderActions.bind(this);
  }

  resendInvite() {
    const { invite } = this.props;
    console.info('Resending invite...', invite, this.props.actions.resendInvite);
    return this.props.actions.resendInvite(invite);
  }

  cancelInvite() {
    const { invite } = this.props;
    console.info('Cancelling invite...', invite, this.props.actions.cancelInvite);
    return this.props.actions.cancelInvite(invite);
  }

  renderStatusLabel(invite) {
    const { approved, redeemed, cancelled } = invite;
    let label = '';

    if (!approved && !cancelled) {
      label = 'Pending Approval';
    } else if (cancelled) {
      label = 'Cancelled';
    } else if (redeemed) {
      label = 'Accepted';
    }

    return (
      <span className="InviteCell__status-label">{label}</span>
    );
  }

  renderActions() {
    const { invite } = this.props;
    if (invite.redeemed) {
      return;
    }

    let options = {
      resend: <a key="resend" className="InviteCell__action" onClick={this.resendInvite}>Resend</a>,
      cancel: <a key="cancel" className="InviteCell__action" onClick={this.cancelInvite}>Cancel</a>
    };

    let actions = [];

    if (invite.approved) {
      actions.push(options.resend);
    }

    actions.push(options.cancel);

    return <div className="InviteCell__actions">
      {actions}
    </div>;
  }

  render() {
    const { invite } = this.props;
    let classNames = ['InviteCell'];

    if (invite.cancelled) {
      classNames.push('InviteCell--cancelled');
    } else {
      classNames.push('InviteCell--accepted');

      // If the invite has yet to be redeemed, show actions.
      if (!invite.redeemed) {
        classNames.push('has-actions');
      }
    }

    return (
      <tr className={classNames.join(' ')}>
        <td className="InviteCell__email">{invite.email}</td>
        <td className="InviteCell__status">
          {this.renderStatusLabel(invite)}

          {this.renderActions()}
        </td>
      </tr>
    );
  }
};

InviteCell.propTypes = {
  invite: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(inviteActions, dispatch)
  };
};

export default connect(null, mapDispatchToProps)(InviteCell);



// WEBPACK FOOTER //
// ./src/components/InviteCell.js